/**
 * Décalage de mise en page insensible aux `transform` (ouverture, `scale`, translations pilotées au défilement) et au
 * collage de `box`, lu sur la chaîne `offsetParent` ; inclut en revanche le décalage de collage si l'élément mesuré (ou un maillon de la chaîne) est lui-même `sticky` : mesurer alors son porteur non collant (`.chslot` pour `#ch-head`, `engine/rush.ts`). Extrait de `engine/cadrage-bind.ts` (passe 8, plan-ecrans §4).
 * Consommateurs : `engine/cadrage-bind.ts` (mesure du cadrage), `engine/rush.ts` (écran titre et rattrapage de la
 * figure 02). Aucun import ; ne lit que `offsetTop`, `offsetParent` et `clientTop` des nœuds fournis ; n'écrit rien.
 */

/**
 * Décalage de mise en page de `el` dans `box` : somme des `offsetTop` le long de la chaîne
 * `offsetParent`, plus le `clientTop` de chaque `offsetParent` intermédiaire (pas celui de `box`).
 * Insensible aux `transform` (ouverture, `scale`) et au collage de `box` (son `offsetTop` n'est pas lu) ; inclut le décalage de collage si `el` ou un `offsetParent` intermédiaire est lui-même `sticky` (son `offsetTop` le porte : mesurer le porteur non collant, `.chslot` pour `#ch-head`). `null` si la chaîne
 * n'atteint pas `box` (jsdom, élément non affiché).
 * @param el élément mesuré
 * @param box ancêtre de référence (son clientTop n'est pas compté)
 * @returns décalage en px, ou null si la chaîne n'atteint pas box
 */
export function offsetWithin(el: HTMLElement, box: HTMLElement): number | null {
  let y = 0;
  let cur: HTMLElement = el;
  while (cur !== box) {
    y += cur.offsetTop;
    const p: Element | null = cur.offsetParent;
    if (!(p instanceof HTMLElement)) return null;
    if (p !== box) y += p.clientTop;
    cur = p;
  }
  return y;
}
